module.exports = __webpack_public_path__ + "img/Logo-8.7e5a1088.svg";